<template>
  <div id="createColumnCategoryWrapper">
    <div class="field">
      <label for="name">Naam</label>
      <div class="control">
        <input type="text" name="name" v-model="name" class="input">
      </div>
    </div>

    <div class="field">
      <save-buttons
        @save="save()"
        @cancel="$emit('close')"></save-buttons>
    </div>
  </div>
</template>

<script>
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'category'
  ],
  components: {
    SaveButtons
  },
  data () {
    return {
      id: null,
      name: null
    }
  },
  watch: {
    category () {
      if (this.category) {
        this.id = this.category.id
        this.name = this.category.name
      } else {
        this.reset()
      }
    }
  },
  methods: {
    save () {
      this.$store.dispatch('columnCategories/save', {
        id: this.id,
        name: this.name
      })

      this.$emit('close')
      this.reset()
    },
    reset () {
      this.id = this.name = null
    }
  }
}
</script>
